import type { FaireProductEntity } from "../../entity_types/product";

export const p_fej92gsnqk: FaireProductEntity = {
  token: "p_fej92gsnqk",
  type: "product",
  name: "Rainbow - Mini Bath Bombs- Gift Bag",
  brandToken: "b_9w42c3xo5a",
  brandName: "Happy Hippo Bath",
  imageUrl:
    "https://cdn.faire.com/fastly/457fb48fa98a4c9bf64209e15b612f0a61e9092084450dcc4c1fa0fcecfa0f87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80f7e5b4bbdad04a753396776cbfbbfb1f030d809536c400ce233b2807a1d187.jpeg",
  ],
  priceDollars: 6.46,
  description:
    "Smells Like: Mountain blueberries & pink lemonade\nSize: 175g of Tiny Bath-Time Magic\n\nWarning: Extreme fun ahead!\n\nToss in a few (or go all out and add a bunch!) and watch these mini bubble bombs fizz and pop with bright colours and tiny bubbles. They smell amazing and leave your skin feeling soft and happy.\n\nTake the fun out of the tub, too — drop them in a water table to make magical potions and experiment with mixing colours.\n",
  tags: [],
  msrpDollars: 13.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:21.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
